export const getNormalizedPhoneNumber = (phoneNumber: string): string =>
  phoneNumber.replace(/[^0-9]/g, "")
